<template>
  <inline-svg
    :src="icon"
    :width="width"
    :height="height"
    :class="`text-${color} ${classColor}`"
  />
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "black",
    },
    name: {
      type: String,
    },
    height: {
      required: true,
    },
    width: {
      required: true,
    },
    classColor:{
      type: String,
      default: 'fill-current'
    }
  },
  computed: {
    icon() {
      return require(`../assets/images/icons/${this.name}.svg`);
    },
  },
  components: {
    InlineSvg: () => import("vue-inline-svg"),
  },
};
</script>
